import { Module } from 'vuex';
import { ILoginQuery } from '@/shared/model/login-query.model';
import { steelblue } from 'color-name';

interface LoginStoreState {
  loginQuery: ILoginQuery;
  redirectServletLoginQuery: ILoginQuery;
  secondFactorRequired: boolean;
  oidcCompat: string;
  embed: boolean;
}

export const loginStore: Module<LoginStoreState, any> = {
  state: {
    loginQuery: null as ILoginQuery,
    redirectServletLoginQuery: null as ILoginQuery,
    secondFactorRequired: false as boolean,
    oidcCompat: null as string,
    embed: false as boolean
  },
  getters: {
    loginQuery: state => state.loginQuery,
    redirectServletLoginQuery: state => state.redirectServletLoginQuery,
    secondFactorRequired: state => state.secondFactorRequired,
    oidcCompat: state => state.oidcCompat,
    embed: state => state.embed
  },
  mutations: {
    setLoginQuery(state, loginQuery) {
      state.loginQuery = loginQuery;
    },
    setRedirectServletLoginQuery(state, redirectServletLoginQuery) {
      state.redirectServletLoginQuery = redirectServletLoginQuery;
    },
    clearLoginStore(state) {
      state.loginQuery = null;
      state.redirectServletLoginQuery = null;
      state.secondFactorRequired = false;
    },
    setSecondFactorRequired(state, secondFactorRequired) {
      state.secondFactorRequired = secondFactorRequired;
    },
    setOidcCompat(state, oidcCompat) {
      state.oidcCompat = oidcCompat;
    },
    setEmbed(state, embed: boolean) {
      state.embed = embed;
    }
  }
};
